import PushNotifications from "@commons/push-notifications";
import React from "react";

const StorePushNotification = () => {
  return <PushNotifications />;
};

export default StorePushNotification;
